/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 
 window.onload=function(){
  let Animation = function() {
  //アイコン位置取得
  let pageTop =  document.getElementById('page_top');

  //要素の位置座標を取得
  let rect = pageTop.getBoundingClientRect();
  //topからの距離
  let scrollTop = rect.top + window.pageYOffset;

  if(scrollTop > 420){
    pageTop.classList.add('show');
   }  else {
    pageTop.classList.remove('show');
   }
 }
  window.addEventListener('scroll', Animation);
}

/*
  2022/3/25 Add Start Timeline
*/
window.addEventListener('DOMContentLoaded', () => {
 const timelineSections = document.querySelectorAll('section[data-section-type="timeline"]');

 //Timelineを読み込む場合、セクションごとに処理
 if(timelineSections.length > 0){
  timelineSections.forEach(section => {
    const sectionId = section.id;
    const slideArrowLeft = document.querySelector(`#${sectionId} .c-SlideArrowLeft`);
    const slideArrowRight = document.querySelector(`#${sectionId} .c-SlideArrowRight`);
    const slideNavItems = section.querySelectorAll(`#${sectionId} .Timeline__NavItem`);
    const firstHeaderHeight = document.querySelector(`#${sectionId} .Timeline__ListItem`).clientHeight;
    let selectedNavItem = "";
    let selectedLineItem = "";
    let nextIndex = 0;
    let prevIndex = 0;
    let navItemIndex=0;

    //Navクリック時の動作
    const clickNavItem = (_navItem)=>{
      navItemIndex=_navItem.dataset.index;
      selectedLineItem=document.querySelector(`#${sectionId} .Timeline__Item[data-index="${String(navItemIndex)}"] .Timeline__Inner`);
      document.querySelector(`#${sectionId} .Timeline__ListItem_forSP`).innerHTML = selectedLineItem.outerHTML;
      document.querySelector(`#${sectionId} .Timeline__ListItem_forSP`).dataset.index = navItemIndex;
    }

    //slideArrowクリック時の動作
    const clickSlideArrow = (_clickedArrow)=>{
      selectedNavItem =  document.querySelector(`#${sectionId} .Timeline__NavItem.is-selected`);
      if(selectedNavItem.dataset.index === "0"){
        //クリック前：最初のアイテムの場合
        if(_clickedArrow === "left"){
          prevIndex = slideNavItems.length - 1;
          document.querySelector(`#${sectionId} .Timeline__NavItem[data-index="${String(prevIndex)}"]`).click();
        }else if(_clickedArrow === "right"){
          nextIndex = Number(selectedNavItem.dataset.index) + 1;
          document.querySelector(`#${sectionId} .Timeline__NavItem[data-index="${String(nextIndex)}"]`).click();
        }
      }else if(selectedNavItem.dataset.index === String(slideNavItems.length - 1)){
        //クリック前：最後のアイテムの場合
        if(_clickedArrow === "left"){
          prevIndex = Number(selectedNavItem.dataset.index) - 1;
          document.querySelector(`#${sectionId} .Timeline__NavItem[data-index="${String(prevIndex)}"]`).click();
        }else if(_clickedArrow === "right"){
          nextIndex = 0;
          document.querySelector(`#${sectionId} .Timeline__NavItem[data-index="${String(nextIndex)}"]`).click();
        }
      }else{
        //クリック前：中間のアイテムの場合
        if(_clickedArrow === "left"){
          prevIndex = Number(selectedNavItem.dataset.index) - 1;
          document.querySelector(`#${sectionId} .Timeline__NavItem[data-index="${String(prevIndex)}"]`).click();
        }else if(_clickedArrow === "right"){
          nextIndex = Number(selectedNavItem.dataset.index) + 1;
          document.querySelector(`#${sectionId} .Timeline__NavItem[data-index="${String(nextIndex)}"]`).click();
        }
      }
    }

    //Timeline__Innerの高さ計算
    // 2022/4/1 Delete カンプに合わせるため、高さをcssで固定指定
    // const calcTimelineHeight = ()=>{
    //   let slideHeaders = document.querySelectorAll(`#${sectionId} .Timeline__ListItem .Timeline__Header`);
    //   let headerHeight = document.querySelector(`#${sectionId} .Timeline__ListItem`).clientHeight;
    //   slideHeaders.forEach(function(headerItem){
    //     //Headerの高さ < Timelineの場合、治るようにTimelineの高さを調整
    //     if(headerHeight < headerItem.clientHeight){
    //       headerHeight = headerItem.clientHeight;
    //     }
    //   });
    //   //Header高さがTimelineより大きい場合、Timelineの高さを調整
    //   if(firstHeaderHeight < headerHeight){
    //     document.querySelector(`#${sectionId} .Timeline__ListItem`).style.height = headerHeight + 'px';
    //   }else{
    //     document.querySelector(`#${sectionId} .Timeline__ListItem`).style.height = firstHeaderHeight + 'px';
    //   }
    // }


    //SlideArrowクリック時、clickSlideArrow関数を呼び出し
    slideArrowLeft.addEventListener('click',()=> clickSlideArrow("left"));
    slideArrowRight.addEventListener('click',()=> clickSlideArrow("right"));


    //Navクリック時の動作
    slideNavItems.forEach(function(navItem){
      navItem.addEventListener('click',()=> clickNavItem(navItem));
    });

    //Timeline__Innerの高さ計算
    // 2022/4/1 Delete カンプに合わせるため、高さをcssで固定指定
    //calcTimelineHeight();
  });
 }

  //2022.3.25 Add Start Footerボタン制御
  const scroll_to_top_btn = document.querySelector('.c-StickyBottomButton');
  //Footerボタンへクリックイベントを追加
  scroll_to_top_btn.addEventListener('click', scroll_to_top);

  function scroll_to_top(){
    window.scroll({top: 0, behavior: 'smooth'});
  };

  //スクロール時の高さ(400)によってボタン表示
  window.addEventListener( 'scroll' , scroll_event );
  function scroll_event(){
    if(window.pageYOffset > 400){
      scroll_to_top_btn.style.opacity = '1';
    }else	if(window.pageYOffset < 400){
      scroll_to_top_btn.style.opacity = '0';
    }
  };

  //2022.3.25 Add Start アンカーリンク制御
  const header_height = document.getElementById('shopify-section-header').clientHeight;
  const ankerlinks = document.querySelectorAll('.c-AnkerLink');
  const ankerlinks_gocup = document.querySelectorAll('.c-AnkerLink.c-AnkerLink-GoCup');

  if(ankerlinks.length > 0){
    ankerlinks.forEach(ankerLink => {
      ankerLink.style.marginTop = `${header_height+60}px`;
      ankerLink.style.paddingTop = `${header_height+60}px`;
    });
  }
  if(ankerlinks_gocup.length > 0){
    ankerlinks_gocup.forEach(ankerLink_gocup => {
      ankerLink_gocup.style.marginTop = `${header_height*-2 +60}px`;
      ankerLink_gocup.style.paddingTop = `${header_height*2 -60}px`;
    });
  }

  //2022.3.28 Add Start 商品ページ Variant未指定時、画像1枚目に紐づくVariantを指定
  const product_section = document.querySelector('section[data-section-type="product"]');
  const page_param = location.search;
  //商品ページの場合 && パラメータにvariant=指定がない場合
  if(product_section && page_param.indexOf('variant=')===-1){
    //サムネイル画像
    const first_image_variant_color = document.querySelector('.Product__Slideshow .Product__SlideItem.is-selected').dataset.variantColor;
    if(first_image_variant_color){
      document.querySelector(`.ColorSwatch__Radio[value="${first_image_variant_color}"]`).click()
    }
  }
});
/*
  2022/3/25 Add  End Timeline
*/